import React, { useEffect, useContext, useState } from 'react';
import './SearchBox.scss';
import { FilterStore } from '../../App';
import Searcher from '../../util/Searcher';
import { ReactComponent as SearchIcon } from '../../assets/icons/search-24px.svg'

export default ({ onSave }) => {
  const { changeGeneralSearch } = useContext(FilterStore).actions;

  const { firstFetched } = useContext(FilterStore).filter;

  const [searchString, setSearchString] = useState('');

  const [suggestions, setSuggestions] = useState([]);


  const allPossibleCases = (arr) => {
    if (arr.length === 1) {
      return arr[0];
    } else {
      var result = [];
      var allCasesOfRest = allPossibleCases(arr.slice(1));  // recur with the rest of array
      for (var i = 0; i < allCasesOfRest.length; i++) {
        for (var j = 0; j < arr[0].length; j++) {
          result.push(arr[0][j] + ' ' + allCasesOfRest[i]);
        }
      }
      return result;
    }

  }

  const buildSuggestions = (response) => {
    let temp = {};
    for (let i = 0; i < response.length; i += 2) {
      if (i % 2 === 0) {
        temp[response[i]] = response[i + 1]
      }
    }

    let wordArray = [];
    for (let word of searchString.split(' ')) {
      if (temp[word.toLowerCase()]) {
        wordArray.push(temp[word.toLowerCase()].suggestion.map((item) => item.word))
      } else {
        wordArray.push([word.toLowerCase()]);
      }
    }

    setSuggestions(allPossibleCases(wordArray));
  }

  useEffect(() => {
    if (searchString && searchString !== '') {
      Searcher.spellCheck(searchString).then((response) => {
        if (response.length > 0) {
          buildSuggestions(response);
        } else {
          setSuggestions([]);
        }
      });
    } else {
      setSuggestions([]);
    }
  }, [searchString]);

  const onStringChange = (text) => {
    setSearchString(text);
    changeGeneralSearch(text);
  }

  const applySuggestion = (suggestion) => {
    onStringChange(suggestion);
  }

  const handleKey = (e) => {
    if (e.which === 13) {
      if (onSave) {
        onSave();
      }
    }
  }

  return (
    <label className="search-box">
      <span className={`search-box__text ${firstFetched ? 'search-box__text--small': ''}`}>Search</span>
      <div className="search-box__input-wrapper">
        <input
          onKeyPress={handleKey}
          onChange={(e) => onStringChange(e.target.value)}
          value={searchString}
          className={`search-box__input ${firstFetched ? 'search-box__input--small': ''}`}
          placeholder="f.e. Chemistry and Camera Complex"
          type="text"
          name="search-box"
        />
        {suggestions.length > 0
          ? (
            <div className="search-suggestions">
              <ul className="search-suggestions__list">
                {suggestions.map((suggestion) => (
                  <li
                    key={suggestion}
                    className="search-suggestions__list__item"
                  >
                    <button
                      onClick={() => applySuggestion(suggestion)}
                    >
                      {suggestion}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )
          : null}
        <button
          onClick={onSave}
          className={`search-box__search-button ${firstFetched ? 'search-box__search-button--small': ''}`}
        >
          <SearchIcon />
        Search
      </button>
      </div>
    </label>
  )
}